import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, unref as _unref, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

import { ref, Ref, reactive, onBeforeMount, computed } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
import tbMix, { cpyCfig } from "@/global_mixin/tableMixin";
import dayjs from 'dayjs'
import { formatNumber, getNumber } from "@/utils/index";
import Api from "@/http/modules/index";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

let {
  // 清单统计-公司
  "POST/salaries/distributes/companies/statistical": fetchList,
  // 清单下拉列表
  "GET/salaries/distributes/select_list": select_listApi,
} = Api;

const {
  MI_tableData,
  fetchData,
  page,
  size,
  MI_total,
  MI_pageChange,
  MI_sizeChange,
  MI_identify,
  MI_params,
  MI_modifyForm,
  MI_height,
} = new tbMix(fetchList);

let distrubutesList = ref([]);
/* onBeforeMount(() => {
  select_listApi().then((rep) => {
    distrubutesList.value = rep
  })
}) */

const searchConfig = ref([
  /* {
    label: '薪酬批次',
    value: '',
    upKey: 'importId',
  }, */
  {
    type: "SELECT",
    label: "薪酬批次",
    value: "",
    upKey: "importIds",
    options: [],
    selectFunc: select_listApi,
    props: { clearable: true, multiple: true, "collapse-tags": true },
    seleProps: { label: "name", valueName: "id", placeholder: "薪酬批次" },
  },
  {
    type: "TIME",
    label: "计提月份",
    value: [dayjs().format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')],
    upKey: "month",
    upProps: { startKey: 'startDate', endKey: 'endDate', },
    props: { type: "monthrange", "value-format": "YYYY-MM-DD" },
  },

  cpyCfig({
    upKey: "companyIds",
    props: { multiple: true, "collapse-tags": true, style: "width: 350px" },
  }),
])

const currentMonths = computed(() => {
  let monthsArray = [];

  let currentMonth = dayjs(MI_params.startDate)
  let _endMonth = dayjs(MI_params.endDate)
  while (currentMonth.isBefore(_endMonth) || currentMonth.isSame(_endMonth, 'month')) {
    monthsArray.push(currentMonth.format('YYYY-MM'));
    currentMonth = currentMonth.add(1, 'month');
  }

  return monthsArray.join(',')
})


const getSummaries = (param: any) => {
  const { columns, data } = param;
  const sums: string[] = ['合计'];
  columns.forEach((column: any, index: number) => {
    if ([0, 1, 8, 9].includes(index)) return;
    const values = data.map((item: any) => Number(item[column.property]));

    if (!values.every((value: any) => Number.isNaN(value))) {
      sums[index] = getNumber(values.reduce((prev: number, curr: number) => {
        const value = Number(curr);
        if (!Number.isNaN(value)) {
          return prev + curr;
        } else {
          return prev;
        }
      }, 0))
    } else {
      sums[index] = "N/A";
    }
  });

  return sums;
};

return (_ctx: any,_cache: any) => {
  const _component_FlexibleForm = _resolveComponent("FlexibleForm")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_collapse, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_collapse_item, { title: "工资类别-搜索" }, {
          default: _withCtx(() => [
            _createVNode(_component_FlexibleForm, _mergeProps({ ref: "searchForm" }, {
            initSearch: true,
            title: true,
            searchConfig: searchConfig.value,
          }, { onSearchFn: _unref(fetchData) }), null, 16, ["onSearchFn"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      ref: "tb",
      border: "",
      data: _unref(MI_tableData),
      "max-height": _unref(MI_height),
      "summary-method": getSummaries,
      "show-summary": ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "分公司",
          prop: "companyName",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "月份",
          prop: "",
          "show-overflow-tooltip": ""
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, _toDisplayString(_unref(currentMonths)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          align: "right",
          formatter: _unref(formatNumber),
          label: "基本工资",
          prop: "basic",
          "show-overflow-tooltip": ""
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          align: "right",
          formatter: _unref(formatNumber),
          label: "业务提成",
          prop: "commission",
          "show-overflow-tooltip": ""
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          align: "right",
          formatter: _unref(formatNumber),
          label: "绩效奖励",
          prop: "reward",
          "show-overflow-tooltip": ""
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          align: "right",
          formatter: _unref(formatNumber),
          label: "合计",
          prop: "actualSalary",
          "show-overflow-tooltip": ""
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          align: "right",
          formatter: _unref(formatNumber),
          label: "实际支付",
          prop: "actualPaySalary",
          "show-overflow-tooltip": ""
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          align: "right",
          formatter: _unref(formatNumber),
          label: "未支付",
          prop: "difference",
          "show-overflow-tooltip": ""
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          width: "500",
          label: "薪酬批次",
          prop: "batchIds",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "支付ID",
          prop: "billIds",
          "show-overflow-tooltip": ""
        })
      ]),
      _: 1
    }, 8, ["data", "max-height"])), [
      [_directive_loading, _unref(MI_identify)]
    ])
  ]))
}
}

})